// ----------------------------------------------------------------------
// <copyright file="Izenda.DataTreeLazyLoading.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React, { PropTypes, Component } from 'react';
import classnames from 'classnames';
import connect from 'share/enhancers/Izenda.Connect';
import { LAZY_LOADING_DATA_SOURCE_TREE_ITEMS } from 'logic/data/Izenda.ReportDesignerConstants';
import LazyLoadingTreeView from 'share/components/controls/LazyLoadingTreeView/Izenda.LazyLoadingTreeView';
import DataCategoryItem from './Izenda.DataCategoryItem';
import DataObjectItem from './Izenda.DataObjectItem';
import DataFieldItem from './Izenda.DataFieldItem';
import Actions from './Izenda.DataSourceTreeActions';
import { invoke } from 'lodash/fp';
@connect(Actions)
class DataTreeLazyLoading extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    expandFieldLevel: PropTypes.bool,
    useCheckBox: PropTypes.bool
  };

  static defaultProps = {
    expandFieldLevel: false,
    useCheckBox: true
  };

  constructor(props) {
    super(props);

    const { store } = props;
    this.lazyLoadingQuerySource = store.lazyLoadingQuerySource.bind(store);
    this.registerLazyLoadingStore = store.registerLazyLoadingStore.bind(store);
  }

  shouldComponentUpdate() {
    return false;
  }

  renderNode = (node, toggleIcon, toggle, isCollapsed) => {
    const { source, nodeType } = node;

    switch (nodeType) {
      case 'Category': {
        return this.renderCategory(source, toggle, isCollapsed);
      }
      case 'QuerySource': {
        return this.renderQuerySource(source, toggleIcon, toggle, isCollapsed, node);
      }
      case 'Field': {
        return this.renderField(source);
      }
      default: {
        return null;
      }
    }
  };

  renderCategory = (node, toggle, isCollapsed) => {
    return <DataCategoryItem dataSource={node} collapseToggle={toggle} isCollapsed={isCollapsed} />;
  };

  renderQuerySource = (source, toggleIcon, toggle, isCollapsed, node) => {
    var { store, useCheckBox, toggleSourceSelection } = this.props;
    var filterText = store.dataTree.filterText;

    return (
      <DataObjectItem
        node={node}
        store={store}
        dataSource={source}
        filterText={filterText}
        toggleIcon={toggleIcon}
        collapseToggle={toggle}
        useCheckBox={useCheckBox}
        isCollapsed={isCollapsed}
        handleCheck={toggleSourceSelection}
      />
    );
  };

  renderField = node => {
    const { store } = this.props;

    return <DataFieldItem store={store} itemData={node} filterText={store.dataTree.filterText} />;
  };

  getKey = node => {
    return node.source.id + '_' + node.source.name;
  };

  render() {
    const props = this.props;
    const {
      store: { dataTree, lazyLoadingStore = {} }
    } = props;
    const displayData = dataTree.displayData;
    const classes = classnames('reports-dtsourcetree', props.className);
    const getChildNodes = invoke('getChildNodes');

    const nodes = displayData.length === 1 && !displayData[0].name ? displayData[0].getChildNodes() : displayData;

    return (
      <div className={classes}>
        <LazyLoadingTreeView
          nodes={nodes}
          getKey={this.getKey}
          className="u_paddingRight"
          renderNode={this.renderNode}
          getChildNodes={getChildNodes}
          viewHeight={lazyLoadingStore.viewHeight}
          itemHeight={lazyLoadingStore.itemHeight}
          isLastPage={dataTree.isLastPage}
          getData={this.lazyLoadingQuerySource}
          defaultItemsNumber={LAZY_LOADING_DATA_SOURCE_TREE_ITEMS}
          registerLazyLoadingStore={this.registerLazyLoadingStore}
        />
      </div>
    );
  }
}

export default DataTreeLazyLoading;



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/DataSourceTree/Izenda.DataSourceTreeLazyLoading.js